export const regulators = [
  {
    name: "Central Bank of Nigeria (CBN)",
  },
  {
    name: "Economic and Financial Crimes Commission (EFCC)",
  },
  {
    name: "Nigerian Upstream Petroleum Regulatory Commission (NUPRC)",
  },
  {
    name: "Nigerian Communications Commission (NCC)",
  },
  {
    name: "Federal Inland Revenue Service (FIRS)",
  },
  {
    name: "National Agency for Food and Drug Administration and Control (NAFDAC)",
  },
  {
    name: "Standards Organisation of Nigeria (SON)",
  },
  {
    name: "National Burea of Statistics (NBS)",
  },
  {
    name: "The National Pension Commission (PENCOM)",
  },
  {
    name: "Nigerian Electricity Regulatory Commission (NERC)",
  },
  {
    name: "Medical and Dental Council of Nigeria (MDCN)",
  },
  {
    name: "Pharmacists Council of Nigeria (PCN)",
  },
  {
    name: "The Consumer Protection Council (CPC)",
  },
  {
    name: "Nigerian Civil Aviation Authority (NCAA)",
  },
  {
    name: "The Securities and Exchange Commission (SEC)",
  },
  {
    name: "Nigerian Postal Service (NIPOST)",
  },
  {
    name: "Nigeria Deposit Insurance Corporation (NDIC)",
  },
  {
    name: "Broadcasting Organisation of Nigeria (BON)",
  },
  {
    name: "West African Examination Council (WAEC)",
  },
  {
    name: "National Environmental Standards and Regulations Enforcement Agency (NESREA)",
  },
  {
    name: "Cocoa Research Institute of Nigeria (CRIN)",
  },
  {
    name: "National Agricultural Extension, Research and Liaison Services (NAERLS)",
  },
  {
    name: "National Veterinary Research Institute (NVRI)",
  },
  {
    name: "Nigerian Agricultural Insurance Corporation (NAIC)",
  },
  {
    name: "National Root Crops Research Institute (NCRI)",
  },
  {
    name: "Agricultural Research Council of Nigeria",
  },
  {
    name: "Nigerian Institute for Oceanography and Marine Research",
  },
  {
    name: "Nigerian Institute for Oil Palm Research (NIFOR)",
  },
  {
    name: "Nigeria Agricultural Quarantine Service (NAQS)",
  },
  {
    name: "National Horticultural Research Institute (NIHORT)",
  },
  {
    name: "Federal Airports Authority of Nigeria (FAAN)",
  },
  {
    name: "Nigerian Airspace Management Agency (NAMA)",
  },
  {
    name: "Nigerian Civil Aviation Authority (NCAA)",
  },
  {
    name: "Nigerian Safety Investigation Bureau (NSIB)",
  },
  {
    name: "Nigerian Meteorological Agency (NIMET)",
  },
  {
    name: "Nigerian College of Aviation Technology (NCAT)",
  },
  {
    name: "National Information Technology Development Agency (NITDA)",
  },
  {
    name: "Nigeria Communications Satellite Limited (NIGCOMSAT)",
  },
  {
    name: "Nigerian Broadcasting Commission (NBC)",
  },
  {
    name: "Nigerian Communications Commission (NCC)",
  },
  {
    name: "Nigerian Postal Service (NIPOST)",
  },
  {
    name: "National Frequency Management Council",
  },
  {
    name: "Nigerian Television Authority (NTA)",
  },
  {
    name: "Galaxy Backbone (GBB)",
  },
  {
    name: "Asset Management Corporation of Nigeria (AMCON)",
  },
  {
    name: "Social Security Administration of Nigeria (SSA)",
  },
  {
    name: "Budget Office of the Federation (BOF)",
  },
  {
    name: "Bureau of Public Enterprises (BPE)",
  },
  {
    name: "Bureau of Public Procurement (BPP)",
  },
  {
    name: "Central Bank of Nigeria (CBN)",
  },
  {
    name: "Debt Management Office (DMO)",
  },
  {
    name: "Federal Inland Revenue Service (FIRS)",
  },
  {
    name: "Federal Mortgage Bank of Nigeria (FMBN)",
  },
  {
    name: "Fiscal Responsibility Commission (FRC)",
  },
  {
    name: "Infrastructure Concession Regulatory Commission (ICRC)",
  },
  {
    name: "National Bureau of Statistics (NBS)",
  },
  {
    name: "National Council on Privatisation (NCP)",
  },
  {
    name: "National Insurance Commission (NAICOM)",
  },
  {
    name: "National Pension Commission (PenCom)",
  },
  {
    name: "National Planning Commission (NPC)",
  },
  {
    name: "National Sugar Development Council (NSDC)",
  },
  {
    name: "Niger Delta Development Commission (NDDC)",
  },
  {
    name: "Nigeria Customs Service (NCS)",
  },
  {
    name: "Nigeria Deposit Insurance Corporation (NDIC)",
  },
  {
    name: "Nigeria Investment Promotion Commission (NIPC)",
  },
  {
    name: "Nigerian Export – Import Bank (NEXIM Bank)",
  },
  {
    name: "Nigerian Export Promotion Council (NEPC)",
  },
  {
    name: "Oil and Gas Free Zones Authority (OGFZA)",
  },
  {
    name: "Nigeria Export Processing Zones Authority (NEPZA)",
  },
  {
    name: "Revenue Mobilisation Allocation and Fiscal Commission (RMAFC)",
  },
  {
    name: "Securities and Exchange Commission (SEC)",
  },
  {
    name: "Standards Organisation of Nigeria (SON)",
  },
  {
    name: "Small and Medium Enterprise Development Agency of Nigeria (SMEDAN)",
  },
  {
    name: "National Board for Arabic And Islamic Studies (NBAIS)",
  },
  {
    name: "Joint Admissions and Matriculation Board (JAMB)",
  },
  {
    name: "National Examination Council (NECO)",
  },
  {
    name: "National Open University of Nigeria (NOUN)",
  },
  {
    name: "National Teachers Institute (NTI)",
  },
  {
    name: "National Universities Commission (NUC)",
  },
  {
    name: "Tertiary Education Trust Fund (TETFUND)",
  },
  {
    name: "Teachers Registration Council of Nigeria (TRCN)",
  },
  {
    name: "National Business and Technical Examinations Board (NABTEB)",
  },
  {
    name: "Universal Basic Education Commission (UBEC)",
  },
  {
    name: "West African Examination Council (WAEC)",
  },
  {
    name: "National Commission for Colleges of Education (NCCE)",
  },
  {
    name: "National Library of Nigeria (NLN)",
  },
  {
    name: "Nigerian Midstream and Downstream Petroleum Regulatory Authority (NMDPRA)",
  },
  {
    name: "Nigerian Upstream Petroleum Regulatory Commission (NUPRC)",
  },
  {
    name: "Electricity Management Services Limited (EMSL)",
  },
  {
    name: "Energy Commission of Nigeria (ECN)",
  },
  {
    name: "National Power Training Institute of Nigeria (NAPTIN)",
  },
  {
    name: "Nigerian Electricity Regulatory Commission (NERC)",
  },
  {
    name: "Nigerian Content Monitoring and Development Board (NCMDB)",
  },
  {
    name: "Nigerian National Petroleum Corporation (NNPC)",
  },
  {
    name: "Nigerian Nuclear Regulatory Authority (NNRA)",
  },
  {
    name: "Petroleum Product Pricing Regulatory Agency (PPPRA)",
  },
  {
    name: "Power Holding Company of Nigeria (PHCN)",
  },
  {
    name: "Rural Electrification Agency (REA)",
  },
  {
    name: "Transmission Company of Nigeria (TCN)",
  },
  {
    name: "Federal Environmental Protection Agency (FEPA)",
  },
  {
    name: "Forestry Research Institute of Nigeria (FRIN)",
  },
  {
    name: "National Biosafety Management Agency (NBMA)",
  },
  {
    name: "National Environmental Standards and Regulations Enforcement Agency (NESREA)",
  },
  {
    name: "National Oil Spill Detection and Response Agency (NOSDRA)",
  },
  {
    name: "Environmental Health Officers Registration Council of Nigeria (EHORECON)",
  },
  {
    name: "National Health Insurance Scheme (NHIS)",
  },
  {
    name: "National Institute for Pharmaceutical Research and Development (NIPRD)",
  },
  {
    name: "National Agency for the Control of AIDS (NACA)",
  },
  {
    name: "National Agency for Food and Drug Administration and Control (NAFDAC)",
  },
  {
    name: "National Primary Health Care Development Agency (NPHCDA)",
  },
  {
    name: "Nigerian Institute of Medical Research (NIMR)",
  },
  {
    name: "Nigeria Centre for Disease Control (NCDC)",
  },
  {
    name: "National Drug Law Enforcement Agency (NDLEA)",
  },
  {
    name: "Defence Intelligence Agency (DIA)",
  },
  {
    name: "State Security Service (SSS)",
  },
  {
    name: "National Intelligence Agency (NIA)",
  },
  {
    name: "Nigerian Financial Intelligence Unit (NFIU)",
  },
  {
    name: "National Judicial Council (NJC)",
  },
  {
    name: "Federal Judicial Service Commission (FJSC)",
  },
  {
    name: "National Judicial Institute (NJI)",
  },
  {
    name: "Nigerian Maritime Administration and Safety Agency (NIMASA)",
  },
  {
    name: "Nigerian Ports Authority (NPA)",
  },
  {
    name: "Nigerian Shippers’ Council (NSC)",
  },
  {
    name: "Broadcasting Organisation of Nigeria (BON)",
  },
  {
    name: "News Agency of Nigeria (NAN)",
  },
  {
    name: "Nigerian Press Council (NPC)",
  },
  {
    name: "Nigerian Television Authority (NTA)",
  },
  {
    name: "National Agency For Science and Engineering Infrastructure (NASENI)",
  },
  {
    name: "National Biotechnology Development Agency (NABDA)",
  },
  {
    name: "National Centre for Remote Sensing (NCRS)",
  },
  {
    name: "Sheda Science and Technology Complex (SHESTCO)",
  },
  {
    name: "National Office for Technology Acquisition and Promotion (NOTAP)",
  },
  {
    name: "National Space Research and Development Agency (NASRDA)",
  },
  {
    name: "Nigerian Nuclear Regulatory Authority (NNRA)",
  },
  {
    name: "Raw Materials Research and Development Council (RMRDC)",
  },
  {
    name: "Nigerian Communications Satellite Ltd (NIGCOMSAT)",
  },
  {
    name: "National Centre for Technology Management (NACETEM)",
  },
  {
    name: "Nigeria Hydrological Services Agency (NIHSA)",
  },
  {
    name: "Nigerian Integrated Water Resources Commission",
  },
  {
    name: "National Water Resources Institute (NWRI)",
  },
  {
    name: "River Basin Development Authorities (RBDA)",
  },
  {
    name: "Centre for Black and African Arts and Civilization (CBAAC)",
  },
  {
    name: "National Automotive Design and Development Council (NADDC)",
  },
  {
    name: "Code of Conduct Bureau (CCB)",
  },
  {
    name: "Computer Professionals Registration Council of Nigeria (CPN)",
  },
  {
    name: "Consumer Protection Council (CPC)",
  },
  {
    name: "Economic and Financial Crimes Commission (EFCC)",
  },
  {
    name: "Federal Character Commission (FCC)",
  },
  {
    name: "Federal Housing Authority (FHA)",
  },
  {
    name: "Independent Corrupt Practices and Other Related Offences Commission (ICPC)",
  },
  {
    name: "Independent National Electoral Commission (INEC)",
  },
  {
    name: "Industrial Training Fund (ITF)",
  },
  {
    name: "Legal Aid Council of Nigeria (LACoN)",
  },
  {
    name: "National Agency for the Prohibition of Trafficking in Persons (NAPTIP)",
  },
  {
    name: "National Boundary Commission",
  },
  {
    name: "National Council of Arts and Culture (NCAC)",
  },
  {
    name: "National Economic Reconstruction Fund (NERFUND)",
  },
  {
    name: "National Emergency Management Agency (NEMA)",
  },
  {
    name: "National Hajj Commission of Nigeria (NaHCON)",
  },
  {
    name: "National Human Rights Commission (NHRC)",
  },
  {
    name: "National Identity Management Commission (NIMC)",
  },
  {
    name: "National Institute for Hospitality Tourism (NIHOTOUR)",
  },
  {
    name: "National Lottery Regulatory Commission",
  },
  {
    name: "National Orientation Agency (NOA)",
  },
  {
    name: "National Population Commission",
  },
  {
    name: "National Poverty Eradication Programme (NAPEP)",
  },
  {
    name: "National Salaries, Incomes and Wages Commission (NSIWC)",
  },
  {
    name: "National Sports Commission (NSC)",
  },
  {
    name: "Nigeria Extractive Industries Transparency Initiative (NEITI)",
  },
  {
    name: "Nigeria Immigration Service (NIS)",
  },
  {
    name: "Nigerian Building and Road Research Institute (NBRRI)",
  },
  {
    name: "Nigeria Institute of Building (NIOB)",
  },
  {
    name: "Nigerian Christian Pilgrim Commission (NCPC)",
  },
  {
    name: "Nigerian Copyright Commission (NCC)",
  },
  {
    name: "Nigerian Tourism Development Corporation (NTDC)",
  },
  {
    name: "Public Complaints Commission, Nigeria",
  },
  {
    name: "Surveyors Council Of Nigeria",
  },
  {
    name: "National Lottery Trust Fund",
  },
  {
    name: "Federal Inland Revenue Service (FIRS)",
  },
  {
    name: "Corporate Affairs Commission (CAC)",
  },
  {
    name: "Debt Management Office (DMO)",
  },
  {
    name: "Federal Mortgage Bank of Nigeria (FMBN)",
  },
  {
    name: "Fiscal Responsibility Commission (FRC) – defunct",
  },
  {
    name: "Infrastructure Concession Regulatory Commission (ICRC)",
  },
  {
    name: "National Bureau of Statistics (NBS)",
  },
  {
    name: "National Council on Privatisation (NCP)",
  },
  {
    name: "National Insurance Commission (NAICOM)",
  },
  {
    name: "National Pension Commission (PenCom)",
  },
  {
    name: "National Planning Commission (NPC)",
  },
  {
    name: "National Sugar Development Council (NSDC)",
  },
  {
    name: "Niger Delta Development Commission (NDDC)",
  },
  {
    name: "Nigeria Customs Service (NCS)",
  },
  {
    name: "Nigeria Deposit Insurance Corporation (NDIC)",
  },
  {
    name: "Nigeria Investment Promotion Commission (NIPC)",
  },
  {
    name: "Nigerian Export – Import Bank (NEXIM Bank)",
  },
  {
    name: "Nigerian Export Promotion Council (NEPC)",
  },
  {
    name: "Oil and Gas Free Zones Authority (OGFZA)",
  },
  {
    name: "Nigeria Export Processing Zones Authority (NEPZA)",
  },
  {
    name: "Revenue Mobilisation Allocation and Fiscal Commission (RMAFC)",
  },
  {
    name: "Securities and Exchange Commission (SEC)",
  },
  {
    name: "Standards Organisation of Nigeria (SON)",
  },
  {
    name: "Small and Medium Enterprise Development Agency of Nigeria (SMEDAN)",
  },
  {
    name: "National Board for Arabic And Islamic Studies (NBAIS)",
  },
  {
    name: "Joint Admissions and Matriculation Board (JAMB)",
  },
  {
    name: "National Examination Council (NECO)",
  },
  {
    name: "National Open University of Nigeria (NOUN)",
  },
  {
    name: "National Teachers Institute (NTI)",
  },
  {
    name: "National Universities Commission (NUC)",
  },
  {
    name: "Tertiary Education Trust Fund (TETFUND)",
  },
  {
    name: "Teachers Registration Council of Nigeria (TRCN)",
  },
  {
    name: "National Business and Technical Examinations Board (NABTEB)",
  },
  {
    name: "Universal Basic Education Commission (UBEC)",
  },
  {
    name: "West African Examination Council (WAEC)",
  },
  {
    name: "National Commission for Colleges of Education (NCCE)",
  },
  {
    name: "National Library of Nigeria (NLN)",
  },
  {
    name: "Nigerian Midstream and Downstream Petroleum Regulatory Authority (NMDPRA)",
  },
  {
    name: "Nigerian Upstream Petroleum Regulatory Commission (NUPRC)",
  },
  {
    name: "Electricity Management Services Limited (EMSL)",
  },
  {
    name: "Energy Commission of Nigeria (ECN)",
  },
  {
    name: "National Power Training Institute of Nigeria (NAPTIN)",
  },
  {
    name: "Nigerian Electricity Regulatory Commission (NERC)",
  },
  {
    name: "Nigerian Content Monitoring and Development Board (NCMDB)",
  },
  {
    name: "Nigerian National Petroleum Corporation (NNPC)",
  },
  {
    name: "Nigerian Nuclear Regulatory Authority (NNRA)",
  },
  {
    name: "Petroleum Product Pricing Regulatory Agency (PPPRA)",
  },
  {
    name: "Power Holding Company of Nigeria (PHCN)",
  },
  {
    name: "Rural Electrification Agency (REA)",
  },
  {
    name: "Transmission Company of Nigeria (TCN)",
  },
  {
    name: "Federal Environmental Protection Agency (FEPA)",
  },
  {
    name: "Forestry Research Institute of Nigeria (FRIN)",
  },
  {
    name: "National Biosafety Management Agency (NBMA)",
  },
  {
    name: "National Environmental Standards and Regulations Enforcement Agency (NESREA)",
  },
  {
    name: "National Oil Spill Detection and Response Agency (NOSDRA)",
  },
  {
    name: "Environmental Health Officers Registration Council of Nigeria (EHORECON)",
  },
  {
    name: "National Health Insurance Scheme (NHIS)",
  },
  {
    name: "National Institute for Pharmaceutical Research and Development (NIPRD)",
  },
  {
    name: "National Agency for the Control of AIDS (NACA)",
  },
  {
    name: "National Agency for Food and Drug Administration and Control (NAFDAC)",
  },
  {
    name: "National Primary Health Care Development Agency (NPHCDA)",
  },
  {
    name: "Nigerian Institute of Medical Research (NIMR)",
  },
  {
    name: "Nigeria Centre for Disease Control (NCDC)",
  },
  {
    name: "National Drug Law Enforcement Agency (NDLEA)",
  },
  {
    name: "Defence Intelligence Agency (DIA)",
  },
  {
    name: "State Security Service (SSS)",
  },
  {
    name: "National Intelligence Agency (NIA)",
  },
  {
    name: "Nigerian Financial Intelligence Unit (NFIU)",
  },
  {
    name: "National Judicial Council (NJC)",
  },
  {
    name: "Federal Judicial Service Commission (FJSC)",
  },
  {
    name: "National Judicial Institute (NJI)",
  },
  {
    name: "Nigerian Maritime Administration and Safety Agency (NIMASA)",
  },
  {
    name: "Nigerian Ports Authority (NPA)",
  },
  {
    name: "Nigerian Shippers’ Council (NSC)",
  },
  {
    name: "Broadcasting Organisation of Nigeria (BON)",
  },
  {
    name: "News Agency of Nigeria (NAN)",
  },
  {
    name: "Nigerian Press Council (NPC)",
  },
  {
    name: "Nigerian Television Authority (NTA)",
  },
  {
    name: "National Agency For Science and Engineering Infrastructure (NASENI)",
  },
  {
    name: "National Biotechnology Development Agency (NABDA)",
  },
  {
    name: "National Centre for Remote Sensing (NCRS)",
  },
  {
    name: "Sheda Science and Technology Complex (SHESTCO)",
  },
  {
    name: "National Office for Technology Acquisition and Promotion (NOTAP)",
  },
  {
    name: "National Space Research and Development Agency (NASRDA)",
  },
  {
    name: "Nigerian Nuclear Regulatory Authority (NNRA)",
  },
  {
    name: "Raw Materials Research and Development Council (RMRDC)",
  },
  {
    name: "Nigerian Communications Satellite Ltd (NIGCOMSAT)",
  },
  {
    name: "National Centre for Technology Management (NACETEM)",
  },
  {
    name: "Nigeria Hydrological Services Agency (NIHSA)",
  },
  {
    name: "Nigerian Integrated Water Resources Commission",
  },
  {
    name: "National Water Resources Institute (NWRI)",
  },
  {
    name: "River Basin Development Authorities (RBDA)",
  },
  {
    name: "Centre for Black and African Arts and Civilization (CBAAC)",
  },
  {
    name: "National Automotive Design and Development Council (NADDC)",
  },
  {
    name: "Code of Conduct Bureau (CCB)",
  },
  {
    name: "Computer Professionals Registration Council of Nigeria (CPN)",
  },
  {
    name: "Consumer Protection Council (CPC)",
  },
  {
    name: "Economic and Financial Crimes Commission (EFCC)",
  },
  {
    name: "Federal Character Commission (FCC)",
  },
  {
    name: "Federal Housing Authority (FHA)",
  },
  {
    name: "Independent Corrupt Practices and Other Related Offences Commission (ICPC)",
  },
  {
    name: "Independent National Electoral Commission (INEC)",
  },
  {
    name: "Industrial Training Fund (ITF)",
  },
  {
    name: "Legal Aid Council of Nigeria (LACoN)",
  },
  {
    name: "National Agency for the Prohibition of Trafficking in Persons (NAPTIP)",
  },
  {
    name: "National Boundary Commission",
  },
  {
    name: "National Council of Arts and Culture (NCAC)",
  },
  {
    name: "National Economic Reconstruction Fund (NERFUND)",
  },
  {
    name: "National Emergency Management Agency (NEMA)",
  },
  {
    name: "National Hajj Commission of Nigeria (NaHCON)",
  },
  {
    name: "National Human Rights Commission (NHRC)",
  },
  {
    name: "National Identity Management Commission (NIMC)",
  },
  {
    name: "National Institute for Hospitality Tourism (NIHOTOUR)",
  },
  {
    name: "National Lottery Regulatory Commission",
  },
  {
    name: "National Orientation Agency (NOA)",
  },
  {
    name: "National Population Commission",
  },
  {
    name: "National Poverty Eradication Programme (NAPEP)",
  },
  {
    name: "National Salaries, Incomes and Wages Commission (NSIWC)",
  },
  { name: "National Sports Commission (NSC)" },
  {
    name: "Nigeria Extractive Industries Transparency Initiative (NEITI)",
  },
  {
    name: "Nigeria Immigration Service (NIS)",
  },
  {
    name: "Nigerian Building and Road Research Institute (NBRRI)",
  },
  {
    name: "Nigeria Institute of Building (NIOB)",
  },
  {
    name: "Nigerian Christian Pilgrim Commission (NCPC)",
  },
  {
    name: "Nigerian Copyright Commission (NCC)",
  },
  {
    name: "Nigerian Tourism Development Corporation (NTDC)",
  },
  {
    name: "Public Complaints Commission, Nigeria",
  },
  {
    name: "Surveyors Council Of Nigeria",
  },
  {
    name: "National Lottery Trust Fund",
  },
  {
    name: "Federal Inland Revenue Service (FIRS)",
  },
  {
    name: "Corporate Affairs Commission (CAC)",
  },
  {
    name: "Debt Management Office (DMO)",
  },
  {
    name: "Federal Mortgage Bank of Nigeria (FMBN)",
  },
  {
    name: "Fiscal Responsibility Commission (FRC) – defunct",
  },
  {
    name: "Infrastructure Concession Regulatory Commission (ICRC)",
  },
  {
    name: "National Bureau of Statistics (NBS)",
  },
  {
    name: "National Council on Privatisation (NCP)",
  },
  {
    name: "National Insurance Commission (NAICOM)",
  },
  {
    name: "National Pension Commission (PenCom)",
  },
  { name: "National Sports Commission (NSC)" },
  {
    name: "Nigeria Extractive Industries Transparency Initiative (NEITI)",
  },
  {
    name: "Nigeria Immigration Service (NIS)",
  },
  {
    name: "Nigerian Building and Road Research Institute (NBRRI)",
  },
  {
    name: "Nigeria Institute of Building (NIOB)",
  },
  {
    name: "Nigerian Christian Pilgrim Commission (NCPC)",
  },
  {
    name: "Nigerian Copyright Commission (NCC)",
  },
  {
    name: "Nigerian Tourism Development Corporation (NTDC)",
  },
  {
    name: "Public Complaints Commission, Nigeria",
  },
  {
    name: "Surveyors Council Of Nigeria",
  },
  {
    name: "National Lottery Trust Fund",
  },
  {
    name: "Federal Inland Revenue Service (FIRS)",
  },
  {
    name: "Corporate Affairs Commission (CAC)",
  },
  {
    name: "Debt Management Office (DMO)",
  },
  {
    name: "Federal Mortgage Bank of Nigeria (FMBN)",
  },
  {
    name: "Fiscal Responsibility Commission (FRC) – defunct",
  },
  {
    name: "Infrastructure Concession Regulatory Commission (ICRC)",
  },
  {
    name: "National Bureau of Statistics (NBS)",
  },
  {
    name: "National Council on Privatisation (NCP)",
  },
  {
    name: "National Insurance Commission (NAICOM)",
  },
  {
    name: "National Pension Commission (PenCom)",
  },
  {
    name: "National Planning Commission (NPC)",
  },
  {
    name: "National Sugar Development Council (NSDC)",
  },
  {
    name: "Niger Delta Development Commission (NDDC)",
  },
  {
    name: "Nigeria Customs Service (NCS)",
  },
  {
    name: "Nigeria Deposit Insurance Corporation (NDIC)",
  },
  {
    name: "Nigeria Investment Promotion Commission (NIPC)",
  },
  {
    name: "Nigerian Export – Import Bank (NEXIM Bank)",
  },
  {
    name: "Nigerian Export Promotion Council (NEPC)",
  },
  {
    name: "Oil and Gas Free Zones Authority (OGFZA)",
  },
  {
    name: "Nigeria Export Processing Zones Authority (NEPZA)",
  },
  {
    name: "Revenue Mobilisation Allocation and Fiscal Commission (RMAFC)",
  },
  {
    name: "Securities and Exchange Commission (SEC)",
  },
  {
    name: "Standards Organisation of Nigeria (SON)",
  },
  {
    name: "Small and Medium Enterprise Development Agency of Nigeria (SMEDAN)",
  },
  {
    name: "National Board for Arabic And Islamic Studies (NBAIS)",
  },
  {
    name: "Joint Admissions and Matriculation Board (JAMB)",
  },
  {
    name: "National Examination Council (NECO)",
  },
  {
    name: "National Open University of Nigeria (NOUN)",
  },
  {
    name: "National Teachers Institute (NTI)",
  },
  {
    name: "National Universities Commission (NUC)",
  },
  {
    name: "Tertiary Education Trust Fund (TETFUND)",
  },
  {
    name: "Teachers Registration Council of Nigeria (TRCN)",
  },
  {
    name: "National Business and Technical Examinations Board (NABTEB)",
  },
  {
    name: "Universal Basic Education Commission (UBEC)",
  },
  {
    name: "West African Examination Council (WAEC)",
  },
  {
    name: "National Commission for Colleges of Education (NCCE)",
  },
  {
    name: "National Library of Nigeria (NLN)",
  },
  {
    name: "Nigerian Midstream and Downstream Petroleum Regulatory Authority (NMDPRA)",
  },
  {
    name: "Nigerian Upstream Petroleum Regulatory Commission (NUPRC)",
  },
  {
    name: "Electricity Management Services Limited (EMSL)",
  },
  {
    name: "Energy Commission of Nigeria (ECN)",
  },
  {
    name: "National Power Training Institute of Nigeria (NAPTIN)",
  },
  {
    name: "Nigerian Electricity Regulatory Commission (NERC)",
  },
  {
    name: "Nigerian Content Monitoring and Development Board (NCMDB)",
  },
  {
    name: "Nigerian National Petroleum Corporation (NNPC)",
  },
  {
    name: "Nigerian Nuclear Regulatory Authority (NNRA)",
  },
  {
    name: "Petroleum Product Pricing Regulatory Agency (PPPRA)",
  },
  {
    name: "Power Holding Company of Nigeria (PHCN)",
  },
  {
    name: "Rural Electrification Agency (REA)",
  },
  {
    name: "Transmission Company of Nigeria (TCN)",
  },
  {
    name: "Federal Environmental Protection Agency (FEPA)",
  },
  {
    name: "Forestry Research Institute of Nigeria (FRIN)",
  },
  {
    name: "National Biosafety Management Agency (NBMA)",
  },
  {
    name: "National Environmental Standards and Regulations Enforcement Agency (NESREA)",
  },
  {
    name: "National Oil Spill Detection and Response Agency (NOSDRA)",
  },
  {
    name: "Environmental Health Officers Registration Council of Nigeria (EHORECON)",
  },
  {
    name: "National Health Insurance Scheme (NHIS)",
  },
  {
    name: "National Institute for Pharmaceutical Research and Development (NIPRD)",
  },
  {
    name: "National Agency for the Control of AIDS (NACA)",
  },
  {
    name: "National Agency for Food and Drug Administration and Control (NAFDAC)",
  },
  {
    name: "National Primary Health Care Development Agency (NPHCDA)",
  },
  {
    name: "Nigerian Institute of Medical Research (NIMR)",
  },
  {
    name: "Nigeria Centre for Disease Control (NCDC)",
  },
  {
    name: "National Drug Law Enforcement Agency (NDLEA)",
  },
  {
    name: "Defence Intelligence Agency (DIA)",
  },
  {
    name: "State Security Service (SSS)",
  },
  {
    name: "National Intelligence Agency (NIA)",
  },
  {
    name: "Nigerian Financial Intelligence Unit (NFIU)",
  },
  {
    name: "National Judicial Council (NJC)",
  },
  {
    name: "Federal Judicial Service Commission (FJSC)",
  },
  {
    name: "National Judicial Institute (NJI)",
  },
  {
    name: "Nigerian Maritime",
  },
];
